import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Activity } from "lucide-react";
import { apiClient, formatApiError } from "@/lib/apiClient";
import { describeActivity } from "@/lib/activity";
import { relativeTime } from "@/lib/dates";
import { toast } from "sonner";
import EmptyState from "@/components/jea/EmptyState";

const PAGE_SIZE = 50;

const ActivityPage = () => {
  const nav = useNavigate();
  const [events, setEvents] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await apiClient.get(`/activity/all?limit=${PAGE_SIZE}`);
        setEvents(data.events || []);
        setTotal(data.total || 0);
      } catch (e) {
        toast.error(formatApiError(e));
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) return null;

  return (
    <div className="space-y-4" data-testid="activity-page">
      <div className="space-y-1">
        <div className="jea-caption">History</div>
        <h1 className="text-[32px] font-extrabold tracking-[-0.02em] text-white">Recent Activity</h1>
        <p className="text-text-secondary text-[14px]">
          A complete log of every action on your account. Showing the {events.length} most recent
          of {total}.
        </p>
      </div>
      {events.length === 0 ? (
        <EmptyState
          icon={Activity}
          title="No activity yet"
          description="Every action you take — adding a judgment, updating a tier, running a query — will show up here."
          testid="activity-page-empty"
        />
      ) : (
        <div className="bg-bg-secondary border border-border-default rounded-[12px] p-2">
          {events.map((e) => {
            const { Icon, color, label } = describeActivity(e);
            return (
              <button
                key={e.id}
                type="button"
                onClick={() => e.debtor_id && nav(`/debtors/${e.debtor_id}`)}
                className="w-full text-left flex items-center gap-4 px-4 py-3 border-b border-border-default last:border-b-0 hover:bg-bg-tertiary rounded-md transition-colors"
                data-testid={`activity-row-${e.id}`}
              >
                <Icon size={18} style={{ color }} strokeWidth={2} className="shrink-0" />
                <div className="flex-1 min-w-0">
                  <div className="text-[14px] font-medium text-white truncate">{label}</div>
                  <div className="text-[12px] text-text-muted">{relativeTime(e.created_at)}</div>
                </div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ActivityPage;
